import { render, staticRenderFns } from "./ProjectPreview.vue?vue&type=template&id=78776540&scoped=true"
import script from "./ProjectPreview.vue?vue&type=script&lang=js"
export * from "./ProjectPreview.vue?vue&type=script&lang=js"
import style0 from "./ProjectPreview.vue?vue&type=style&index=0&id=78776540&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78776540",
  null
  
)

export default component.exports